import { 
    GET_ADMINS, 
    GET_ADMIN_MANAGER, 
    GET_EXPIRED_ADMINS, 
    DASHBOARD_COUNTS, 
    ADD_SUBADMIN, 
    UPDATE_SUBADMIN, 
    DELETE_SUBADMIN,
    ADD_SUPER_ADMIN,
    DELETE_SUPER_ADMIN,
    UPDATE_SUPER_ADMIN,
    GET_SUPER_ADMIN,
    GET_ALL_SUPER_ADMINS
} from '../actions/SuperAdmin.action';

const initialState = {
    getAdmins: '',
    getManagersByAdmin: '',
    getExpiredAdmins: '',
    dashboardCounts: '',
    addSubAdmin: '',
    updateSubAdmin: '',
    deleteSubAdmin: '',
    // New state properties for Super Admin
    addSuperAdmin: '',
    deleteSuperAdmin: '',
    updateSuperAdmin: '',
    getSuperAdmin: '',
    getAllSuperAdmins: ''
}

const SuperAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ADMINS:
            return { ...state, getAdmins: action.payload }
        case GET_ADMIN_MANAGER:
            return { ...state, getManagersByAdmin: action.payload }
        case GET_EXPIRED_ADMINS:
            return { ...state, getExpiredAdmins: action.payload }
        case DASHBOARD_COUNTS:
            return { ...state, dashboardCounts: action.payload }
        case ADD_SUBADMIN:
            return {...state, addSubAdmin: action.payload }
        case UPDATE_SUBADMIN:
            return {...state, updateSubAdmin: action.payload }
        case DELETE_SUBADMIN:
            return {...state, deleteSubAdmin: action.payload }
        case ADD_SUPER_ADMIN:
            return { ...state, addSuperAdmin: action.payload }
        case DELETE_SUPER_ADMIN:
            return { ...state, deleteSuperAdmin: action.payload }
        case UPDATE_SUPER_ADMIN:
            return { ...state, updateSuperAdmin: action.payload }
        case GET_SUPER_ADMIN:
            return { ...state, getSuperAdmin: action.payload }
        case GET_ALL_SUPER_ADMINS:
            return { ...state, getAllSuperAdmins: action.payload }
        default:
            return { ...state }
    }
}

export default SuperAdminReducer